define('areas/navigationmanager/commands/savenavigationmodelcommand',["require", "exports"], function (require, exports) {
    "use strict";
    var SaveNavigationModelCommand = (function () {
        function SaveNavigationModelCommand(process) {
            this._part = process;
        }
        SaveNavigationModelCommand.prototype.execute = function (symbol) {
            this._part.process(symbol);
        };
        return SaveNavigationModelCommand;
    }());
    return SaveNavigationModelCommand;
});

